import app from 'flarum/common/app';
import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
export default class Answer extends Model {
  content = Model.attribute('content');
  fieldId = Model.attribute('fieldId');
  field = computed('fieldId', fieldId => app.store.getById('masquerade-fields', fieldId));
  userId = Model.attribute('user_id');
}
flarum.reg.add('fof-masquerade', 'lib/models/Answer', Answer);